import urlConfig from './proxy-boe-ppe'

export function validatePhone(phone: string | number): boolean {
  return /^\d{11}$/.test(`${phone}`)
}

export function toNumber(value: string | number): number {
  const numberValue = Number(value)
  return Number.isNaN(numberValue) ? 0 : numberValue
}

export function unicodeToChar(text: string) {
  return text.replace(/\\u[\dA-F]{4}/gi, function(match) {
    return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
  })
}

export function getBoundingClientRect(element: HTMLElement | Element) {
  const rect = element.getBoundingClientRect()
  // whether the IE version is lower than 11
  const isIE = navigator.userAgent.indexOf('MSIE') !== -1

  // fix ie document bounding top always 0 bug
  const rectTop =
    isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top

  return {
    left: rect.left,
    top: rectTop,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.right - rect.left,
    height: rect.bottom - rectTop,
  }
}

export const isDEV = process.env.NODE_ENV === 'development'

export const isBOE =
  process.env.server === 'boe' || process.env.TCE_HOST_ENV === 'boe'

export const isPPE =
  process.env.server === 'ppe' || process.env.TCE_HOST_ENV === 'ppe'

export const ttEnv = process.env.ttEnv || process.env.TCE_ENV

export const isMatchHeaderUrl = (url: string) => {
  if (!url) {
    return false
  }
  const len = urlConfig.length
  for (let i = 0; i < len; i++) {
    const item = urlConfig[i]
    if (item && url.indexOf(item) > -1) {
      return true
    }
  }
  return false
}

export const handleAsPath = (asPath: string) => {
  const search = asPath?.split('?')?.[1]
  const queries = {} as any
  if (search) {
    search.split('&').forEach(function(c: string) {
      if (c === '') {
        return
      }
      const splitArr = c.split('=')
      const [key, value] = splitArr
      queries[key] = decodeURIComponent(value)
    })
  }
  return queries
}
